import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./index.css";
import "./lib/i18n";
import { bindNotificationTapNavigation } from "./lib/notification-navigation";

// Register the service worker (vite-plugin-pwa). autoUpdate keeps the app on
// the latest version; reload happens seamlessly.
registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(<App />);

// Route notification taps to their order (message from the FCM worker for a
// running app, stashed intent for a cold start). Bound immediately — the tap
// may be the very reason the app is opening.
bindNotificationTapNavigation();

// Register for web push notifications once auth has had a chance to restore.
// Lazy-imported so the (large) firebase bundle only loads when needed.
window.addEventListener("load", () => {
  setTimeout(async () => {
    // Only attempt push registration if the user is logged in.
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const { registerPushNotifications } = await import(
        "./lib/firebase-messaging"
      );
      await registerPushNotifications();
    } catch (error) {
      console.error("[PWA] push registration failed:", error);
    }
  }, 1500);
});
